export default __webpack_public_path__ + "static/media/bug.8eff26ad.svg";